window.addEventListener('DOMContentLoaded', function () {
  if ($('.header__outer-wrapper').length > 0) {
    //scroll event throttler to stop the browser from overworking
    const throttleDuration = 200;
    var scrollTimeout;
    function scrollThrottler(e) {
      // ignore scroll events as long as an checkScroll execution is in the queue
      if (!scrollTimeout) {
        scrollTimeout = setTimeout(function () {
          scrollTimeout = null;
          toggleHeader(e);
          // The checkScroll will execute at a rate of
        }, throttleDuration);
      }
    }

    const $header = $('.header__outer-wrapper');
    let placeholderHeight = window.scrollY;
    function toggleHeader(e) {
      var scrollheight = window.scrollY;
      if (scrollheight < placeholderHeight - 70 || scrollheight < 300) {
        $header.removeClass('hide');
      } else if (scrollheight > 300 && scrollheight > placeholderHeight) {
        $header.addClass('hide');
      }

      if (scrollheight < 500) {
        $header.removeClass('not-near-top');
      } else {
        $header.addClass('not-near-top');
      }

      placeholderHeight = window.scrollY;
    }

    window.addEventListener('scroll', scrollThrottler, { passive: true });
  }

  // header currency select
  function localizationFormSubmit(event) {
    event.target.form.submit();
  }
  document.querySelectorAll('.shopify-localization-form .js-currency-select-header').forEach(function (element) {
    element.addEventListener('change', localizationFormSubmit);
  });

  // instagram feed
  if (document.querySelectorAll('.instafeed').length > 0) {
    var instafeedLimit = document.querySelector('.instafeed').dataset.count;

    var feed = new Instafeed({
      accessToken: InstagramToken,
      limit: parseInt(instafeedLimit),
      template: '<a href="{{link}}" target="_blank"><img alt="Roomytown Instagram" src="{{image}}" /></a>',
    });

    feed.run();
  }
  // product details accordion
  if (document.querySelectorAll('.accordion-tab').length > 0) {
    function toggleAccordionClass(e) {
      e.preventDefault();
      // get appropriate accordion elements
      const targetButton = e.currentTarget;
      const targetIndex = targetButton.getAttribute('data-accordion-index');
      const contentSection = document.querySelector('.accordion-content[data-accordion-index="' + targetIndex + '"');
      const contentInnerEl = document.querySelector('.accordion-content[data-accordion-index="' + targetIndex + '"] .content-inner');
      // depending on the current expanded status - toggle syles and attributes
      if (targetButton.classList.contains('is-active')) {
        targetButton.setAttribute('aria-expanded', 'false');
        contentSection.setAttribute('aria-hidden', 'true');
        contentSection.style.height = '0px';
      } else {
        targetButton.setAttribute('aria-expanded', 'true');
        contentSection.setAttribute('aria-hidden', 'false');
        contentSection.style.height = contentInnerEl.scrollHeight + 'px';
      }
      contentSection.classList.toggle('is-active');
      targetButton.classList.toggle('is-active');
    }

    if (document.querySelector('.accordion-content[data-accordion-index="0"]')) {
      // set description content section's height explicitly
      document.querySelector('.accordion-content[data-accordion-index="0"]').style.height =
        document.querySelector('.accordion-content[data-accordion-index="0"] .content-inner').scrollHeight + 'px';
    }

    //set event listeners for all tabs
    const elementList = document.querySelectorAll('.accordion-button');
    for (x = 0; x < elementList.length; x++) {
      elementList[x].addEventListener('click', toggleAccordionClass);
    }

    $('.js-go-to-sizes').click(function (e) {
      var target = $('#sizes');
      var headerHeight = $('header.header').outerHeight();
      var scrollPosition = target.offset().top - headerHeight;

      $('html').animate(
        {
          scrollTop: scrollPosition,
        },
        1000,
        function () {
          if (!document.querySelector('#sizes button.accordion-button').classList.contains('is-active')) {
            $('#sizes button.accordion-button').click();
          }
        }
      );
    });
  }

  if ($('.thumbnail-carousel').length > 0) {
    $('.thumbnail-carousel').owlCarousel({
      margin: 10,
      autoWidth: true,
      items: 4,
      dots: false,
      autoplay: true,
      autoplayTimeout: 15000,
      autoplayHoverPause: true,
    });
  }

  if ($('.sizes-carousel').length > 0) {
    $('.sizes-carousel').owlCarousel({
      margin: 10,
      autoWidth: true,
      items: 4,
      dots: false,
    });
  }

  // when a product has swatches... update the label on click
  if ($('.product-form__color-swatches').length > 0) {
    $('.product__color-swatch').click(function (e) {
      // make the first character a capital letter
      var label = e.target.dataset.label.charAt(0).toUpperCase() + e.target.dataset.label.slice(1);
      $('.js-update-swatch-value').text(label);
    });
  }

  if ($('#personalised').length > 0) {
    const $addToCartButton = $('.product-form__cart-submit');
    //if product personalizer is present
    if ($('.product-personalizer').length > 0) {
      $('.product-personalizer').insertBefore($addToCartButton);
      $addToCartButton.css({ display: 'none' });
    } else {
      const productForm = document.querySelector('form[action="/cart/add"]');

      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Callback function to execute when mutations are observed
      const callback = function (mutationsList, observer) {
        // Use traditional 'for loops' for IE 11
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // find the personalise button
            if (mutation.addedNodes[0].firstChild.classList.contains('pplr-btn')) {
              const $personaliseButton = $('.product-personalizer');
              $personaliseButton.insertBefore($addToCartButton);
              $addToCartButton.css({ display: none });
              // then remove observer
              observer.disconnect();
            }
          }
        }
      };
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(productForm, config);
      // Later, you can stop observing
    }
  }

  /// ----------------------------------------------------------------------- instagram feed
  if ($('.insta_feed_section').length > 0) {
    var $span = $('.insta_feed_section .insta_box');
    for (var i = 0; i < $span.length; i += 5) {
      var $div = $('<div/>', {
        class: 'insta_class',
      });
      $span.slice(i, i + 5).wrapAll($div);
    }
  }

  // ----------------------------------------------------------------------- regional conditions
  const useRegionalConditions = window.regionalConditions.enableRegionalConditions || undefined;

  if (useRegionalConditions) {
    // make regions uppercase anc an array of values.
    const regionsArray = window.regionalConditions.regionCodes.toUpperCase().split(',');
    // return any escaped characters to standard text.
    const variantNames = $('<textarea />').html(window.regionalConditions.variantNames).text();
    const hideHangers = window.regionalConditions.hideHangers;
    const isProductPage = window.regionalConditions.isProductPage;

    let userRegionCookie = getUserRegionCookie() || null;
    // let userRegionCookie = 'NZ';

    function getUserRegionCookie() {
      return Cookies.get('usersRegion');
    }

    function setUsersRegionCookie(regionCode) {
      Cookies.set('usersRegion', regionCode, {
        expires: 30,
      }); // set to expire after 30 days
      userRegionCookie = regionCode;
      return;
    }

    function getUsersCountryCode() {
      $.ajax({
        url: 'https://ipinfo.io/json',
        type: 'GET',
        dataType: 'jsonp',
        success: function success(response) {
          var usersCountryCode = response.country;
          setUsersRegionCookie(usersCountryCode);
          if (isProductPage) {
            determineRegion();
          }
          return;
        },
        error: function (xhr, status, error) {
          console.log('API fetch error =', error);
          return;
        },
      });
    }

    (function initRegionalConditions() {
      if (userRegionCookie === null) {
        // get users region
        getUsersCountryCode();
      } else {
        if (isProductPage) {
          determineRegion();
        }
      }
    })();

    function determineRegion() {
      // is user region present in the array
      if (regionsArray.indexOf(userRegionCookie) > -1) {
        if (hideHangers) {
          removeLinksToHangers();
        }
        if (variantNames !== '') {
          removeVariants();
        }
      }
    }

    function removeLinksToHangers() {
      if ($('.js-hanger').length > 0) {
        $('.js-hanger').remove();
      }
    }

    function removeVariants() {
      const variantNamesArray = variantNames.split(',');
      const $selectOptions = $('option');

      // loop through the variantArray, for each one loop through the options to look for a match
      for (let i = 0; i < variantNamesArray.length; i++) {
        $selectOptions.each(function () {
          let variant = variantNamesArray[i].trim();
          if (variant === this.value) {
            this.remove();
            // console.log('see ya =');
          }
        });
      }
    }
  }

  // for newslatter signup modal - opened from a button in the footer
  MicroModal.init({
    openClass: 'is-open',
    disableScroll: true,
  });
});
